import ApiService from './api-service'
// const camelToSnakeCase = str => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

class Asset extends ApiService {
    constructor() {
        super()

        // this.get = null
        this.post = null
        this.put = null
        this.delete = null
    }

    list(options) {
      return super.get('/asset', options)
    }


    clear(id) {
      if(id) return super.clear(`/asset/${id}`)
      return super.clear('/asset')
    }


    get(id, options) {
      return super.get(`asset/${id}`, options)
    }

    getUploadUrl(id, payload, options) {
      payload = payload || {}
      return super.post(`upload${id ? `/${id}` : ``}`, payload, options)
    }

    getUrl(id, options = {}) {
      return super.get(`get${id ? `/${id}` : ``}/public/url`, options)
    }
}

const _Asset = new Asset()
export default _Asset
